import { TR, TDT, TA } from "../../components";
import { FaCheckCircle } from "react-icons/fa";
import { FiEdit2 } from "react-icons/fi";
import { MdCancel } from "react-icons/md";
import { RiDeleteBin5Line } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import TableContext from "../Provider/TableContext";
import useApp from "../../../../Hooks/useApp";
import { hasOtherPermission } from "../../../../Util/Permissions";

function TableRow(props) {
  const { doc } = props;
  const { user, setShowNotAuthorized } = useApp();
  const navigate = useNavigate();
  const {
    setShowApproveModal,
    setShowCancelModal,
    setShowDeleteModal,
    setOrderId,
  } = useContext(TableContext);

  function showDelete() {
    setOrderId(doc?.id);
    setShowDeleteModal(true);
  }

  function showApprove() {
    setOrderId(doc?.id);
    setShowApproveModal(true);
  }

  function showCancel() {
    setOrderId(doc?.id);
    setShowCancelModal(true);
  }

  function handleAuth() {
    setShowNotAuthorized(true);
  }

  return (
    <TR>
      {/* <TDT name="REQUEST ID" txt={doc?.request_id || "--"} /> */}
      <TDT name="ITEM NAME" txt={doc?.item_name || "--"} />
      <TDT name="QUANTITY" txt={doc?.quantity || "--"} />
      <TDT name="TOTAL AMOUNT" txt={doc?.total_cost || "--"} />
      <TDT name="DESCRIPTION" txt={doc?.description || "--"} />
      <TDT
        name="APPROVED BY"
        txt={
          doc?.members_purchase_orders_approved_byTomembers?.name ||
          doc?.members_purchase_orders_approved_byTomembers?.full_name ||
          "--"
        }
      />
      <TDT
        name="CREATED BY"
        txt={
          doc?.members_purchase_orders_created_byTomembers?.name ||
          doc?.members_purchase_orders_created_byTomembers?.full_name ||
          "--"
        }
      />

      <TDT
        name="STATUS"
        txt={
          <div
            className={`rounded-2xl w-fit px-4 ${
              doc?.request_status?.name === "pending"
                ? "bg-red"
                : doc?.request_status?.name === "approved"
                ? "bg-green"
                : "bg-secondary"
            } `}
          >
            <p className="text-md text-white">
              {doc?.request_status?.name || "--"}
            </p>
          </div>
        }
      />

      <TA name="ACTIONS" id={doc?.id}>
        <div className="flex flex-col gap-4">
          {/* Edit button - only for pending */}
          {doc?.request_status?.name === "pending" && (
            <div
              className="cursor-pointer"
              onClick={() => navigate(`edit/${doc?.id}`)}
            >
              <p className="text-center text-xl flex gap-2">
                <FiEdit2 className="text-blue-500 text-2xl text-center" />
                <span>Edit</span>
              </p>
            </div>
          )}

          {/* Approve button - only for non-approved, non-cancelled */}
          {doc?.request_status?.name !== "approved" &&
            doc?.request_status?.name !== "cancelled" && (
              <div
                className="cursor-pointer"
                onClick={
                  hasOtherPermission(user, "approve_purchase_order")
                    ? showApprove
                    : handleAuth
                }
              >
                <p className="text-center text-xl flex gap-2">
                  <FaCheckCircle className="text-green-500 text-2xl text-center" />
                  <span>Approve</span>
                </p>
              </div>
            )}

          {/* Cancel button - with permission check */}
          <div
            className="cursor-pointer"
            onClick={
              hasOtherPermission(user, "cancel_purchase_order")
                ? showCancel
                : handleAuth
            }
          >
            <p className="text-center text-xl flex gap-2">
              <MdCancel className="text-2xl text-center text-red" />
              <span>Cancel</span>
            </p>
          </div>

          {/* DELETE BUTTON - TEMPORARY FIX: Permission check REMOVED */}
          <div
            className="cursor-pointer"
            onClick={showDelete}  // ✅ Permission check removed - will always work
          >
            <p className="text-center text-xl flex gap-2">
              <RiDeleteBin5Line className="text-2xl text-center text-red" />
              <span>Delete</span>
            </p>
          </div>
        </div>
      </TA>
    </TR>
  );
}

export default TableRow;